import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { getDataScopeByPermission } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserService } from '../../services/user-service.service';

@Component({
  selector: 'laas-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.scss']
})
export class UserSearchComponent extends SessionBaseComponent implements OnInit, AfterViewInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.ViewUser;
  readonly helpPermissionCode: PermissionConstants = PermissionConstants.ViewManageUser;
  currentLang: string = this.laasSetting.language;
  isSearchFormOpen:boolean;
  account:string;
  email:string;
  userName:string;
  userResults: any[];
  isLoading:boolean;

  constructor(
    injector: Injector,
    private userDataService: UserService
  ) {
    super(injector);
    this.isSearchFormOpen = true;
    this.isLoading = false;
    this.account = "";
    this.email = "";
    this.userName = "";
    this.userResults = [];
  }
  ngAfterViewInit(): void {

  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    console.log('userprofile: ');
    console.log(this.userProfile);

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if(!canInPage){
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    setTimeout(() => {
      this.searchBtnClick(null);
    }, 500);
  }

  resetBtnClick(evt: any): void{
    this.account = "";
    this.email = "";
    this.userName = "";
  }

  gotoModify(evt: any, user:any): void {
    this.routeStateService.navigateTo('/User/userModify', {userId: user.uuid});
  }

  addMember(evt: any): void {
    this.routeStateService.navigateTo('/User/userModify');
  }

  previewUser(event: any, roleScope: any): void{
    this.routeStateService.navigateTo('/User/userPreview', {userId: roleScope.uuid});
  }

  searchBtnClick(evt: any): void {
    this.isLoading = true;
    var filter = {
      account: this.account,
      email: this.email,
      userName: this.userName,
      dataScopes: getDataScopeByPermission(this.userProfile, this.permissionCode),
      userType: this.userProfile.userType
    };

    this.userDataService.getUsers(filter).subscribe({
      next: result => {
        this.userResults = result;
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }
}
